// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__13PUG","PageIndicator":"Pagination_PageIndicator__1rqIb","Active":"Pagination_Active__3V3D_"};